<script>
import ProcessesController from "../../../Mixins/ProcessesController";
import Breadcrumbs from "../../../Comps/General/Breadcrumbs.vue";
import HeaderName from "../../../Comps/General/HeaderName.vue";
import AccidentReportForm from "../../../Comps/Staff/AccidentReports/AccidentReportForm.vue";

export default {
    name: "Edit",
    components: { AccidentReportForm, HeaderName, Breadcrumbs },

    mixins: [ProcessesController],

    data() {
        return {
            bread: [
                {
                    text: "Accident reports",
                    disabled: false,
                    link: this.route("accident-reports.index"),
                },
                {
                    text: `Accident report - ${this.$page.props.accidentReport.job_reference}`,
                    disabled: false,
                    link: this.route(
                        "accident-reports.show",
                        this.$page.props.accidentReport
                    ),
                },
                {
                    text: "Edit",
                    disabled: true,
                },
            ],
            form: this.$inertia.form({}),
        };
    },

    mounted() {
        this.form = this.$inertia.form(this.$page.props.accidentReport);
    },

    methods: {
        edit() {
            this.form.put(this.route("accident-reports.update", this.form.id));
        },
    },
};
</script>

<template>
    <div>
        <header-name>Edit accident report</header-name>

        <breadcrumbs :items="bread" />

        <div class="mt-8">
            <accident-report-form v-model="form" @submitForm="edit" />
        </div>
    </div>
</template>

<style scoped></style>
